'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  customBackgroundColor: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['default', 'blank', 'dense']),
  theme: _propTypes2.default.object
};

var defaultProps = {
  customBackgroundColor: '',
  size: 'default'
};

/** PROP RECEIVERS */
var sizeProps = function sizeProps(_ref) {
  var size = _ref.size,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = size !== 'default' ? theme.reactackle.components.header.header.size[size] : theme.reactackle.components.header.header.size;

  return '\n    min-height: ' + (0, _reactackleCore.getValueString)(source.minHeight) + ';\n  ';
};

var baseProps = function baseProps(_ref2) {
  var themeFromProvider = _ref2.theme,
      customBackgroundColor = _ref2.customBackgroundColor;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.header.header,
      zIndex = _theme$reactackle$com.zIndex,
      backgroundColor = _theme$reactackle$com.backgroundColor;


  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];

  var headerBackground = customBackgroundColor || backgroundColor;

  return '\n    background-color: ' + headerBackground + ';\n    z-index: ' + zIndex + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
};

/** STYLES */
var HeaderStyled = exports.HeaderStyled = _styledComponents2.default.header.withConfig({
  displayName: 'HeaderStyled'
})(['padding:0;position:relative;width:100%;', ';', ';', ';'], baseProps, sizeProps, (0, _reactackleCore.transition)('height'));

HeaderStyled.propTypes = propTypes;
HeaderStyled.defaultProps = defaultProps;
HeaderStyled.displayName = 'HeaderStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-header/dist/styles/HeaderStyled.js
// module id = 705
// module chunks = 0